import React, {
  PureComponent,
  HTMLAttributes,
  CSSProperties,
  KeyboardEvent, ChangeEvent
} from 'react'
import PropTypes from 'prop-types'
import cxs from 'cxs/component'
import Theme, {easing} from 'Theme'
import {Button, Icon} from 'elements'

interface Props extends HTMLAttributes<HTMLInputElement> {
  type: string
  name?: string
  value?: string | number
  label?: string
  underline?: boolean
  min?: number
  max?: number
  maxLength?: number
  onSubmit?(): void
  onChange?(event: ChangeEvent<HTMLInputElement>)
}

interface State {
  active: boolean
  secure: boolean
}

class Input extends PureComponent<Props, State> {
  static defaultProps = {
    underline: true
  }

  state: State = {
    active: false,
    secure: this.props.type === 'password'
  }

  handleActive = active => () => this.setState({active})

  handleKeyPress = (event: KeyboardEvent<HTMLInputElement>) => {
    if (this.props.onSubmit && event.nativeEvent.keyCode === 13)
      this.props.onSubmit()
  }

  toggleSecure = () => this.setState({secure: !this.state.secure})

  handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    // console.log('Input- handleChange', event.target.value)
  }

  render() {
    const {
      type,
      name,
      value,
      label,
      underline,
      min,
      max,
      maxLength,
      onSubmit,
      ...props
    } = this.props
    const {active, secure} = this.state
    // console.log('Input - value: ', value)
    const unfolded = active || String(value).length > 0
    return (
      <Wrapper {...props}>
        {label ? (
          <Label active={active} unfolded={unfolded}>
            {label}
          </Label>
        ) : null}
        <StyledInput
          type={secure ? 'password' : 'text' || type}
          name={name}
          value={value}
          underline={underline}
          active={active}
          onChange={this.handleChange}
          onFocus={this.handleActive(true)}
          onBlur={this.handleActive(false)}
          min={min}
          max={max}
          maxLength={maxLength}
          onKeyPress={onSubmit ? this.handleKeyPress : undefined}
          secure={secure}
        />
        {type === 'password' && (
          <StyledButton onClick={this.toggleSecure}>
            <StyledIcon name={secure ? 'show' : 'hide'} />
          </StyledButton>
        )}
      </Wrapper>
    )
  }
}

export default Input

const Wrapper = cxs('label')({
  display: 'block',
  width: '100%',
  position: 'relative'
} as CSSProperties)

const Label = cxs('div')(
  ({active, unfolded}) =>
    ({
      height: Theme.fontSize.regular,
      fontSize: unfolded ? Theme.fontSize.small : Theme.fontSize.regular,
      color: active ? Theme.color.primary : Theme.color.placeholder,
      textAlign: 'left',
      transform: `translateY(${unfolded ? 0 : '100%'})`,
      transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms'
    } as CSSProperties)
)

Label.propTypes = {
  active: PropTypes.bool,
  unfolded: PropTypes.bool
}

const StyledInput = cxs('input')(
  ({underline, active, secure}) =>
    ({
      width: '100%',
      height: '100%',
      transition: `border-color 450ms ${easing.spring} 0ms`,
      paddingRight: secure !== undefined ? Theme.size.space[3] : 0,
      ...underline
        ? {
            borderBottom: `${Theme.size.hairline} solid ${active
              ? Theme.color.primary
              : Theme.color.hairline}`
          }
        : undefined
    } as CSSProperties)
)

StyledInput.propTypes = {
  active: PropTypes.bool,
  underline: PropTypes.bool,
  secure: PropTypes.bool
}

const StyledButton = cxs(Button)({
  position: 'absolute',
  bottom:
    Theme.common.size.font * (Theme.common.size.lineHeight - 1) / 2 + 'px',
  right: 0
} as CSSProperties)

const StyledIcon = cxs(Icon)({
  color: Theme.color.placeholder
} as CSSProperties)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/elements/Input.tsx